import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=7dbb7f7c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbb7f7c')) {
      api.createRecord('7dbb7f7c', component.options)
    } else {
      api.reload('7dbb7f7c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=7dbb7f7c&", function () {
      api.rerender('7dbb7f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJ0FwAMOH3Ye/JS/comp/ImgFallback.vue"
export default component.exports